{
  "categoryCard": {
    "dropdown": {
      "translationButton": "Voir les traductions",
      "editButton": "Modifier",
      "deleteButton": "Supprimer"
    },
    "questionsCount": "{{questionCount}} questions",
    "noQuestions": "Pas encore de questions",
    "exploreQuestionsButton": "Explorer d'autres questions",
    "addQuestionsButton": "Ajouter des questions",
    "lastAskedText": "Dernière question",
    "notAskedText": "Pas encore posé",
    "satisfactionScoreText": "Score de satisfaction"
  },
  "teamPerformanceCard": {
    "comparedToAverage": {
      "more": "plus que la moyenne de l'entreprise",
      "less": "moins que la moyenne de l'entreprise",
      "same": "égal à la moyenne de l'entreprise"
    },
    "companyBaseline": "Référence de l'entreprise {{score}}",
    "notEnoughResponses": "Pas assez de réponses"
  },
  "insightsCard": {
    "responseCount": "{{responseCount}} réponses"
  },
  "integrationCard": {
    "status": {
      "connected": {
        "verified": "Vérifié",
        "configured": "Configuré",
        "connected": "Connecté",
        "managed": "Géré"
      },
      "notConnected": {
        "verify": "Vérifier",
        "configure": "Configurer",
        "connect": "Connecter",
        "manage": "Gérer"
      }
    }
  },
  "questionHistoryRow": {
    "responseCount_one": "{{formattedResponses}} réponse",
    "responseCount_other": "{{formattedResponses}} réponses",
    "insufficientResponses": "Réponses insuffisantes",
    "questionButton": "Voir les détails"
  },
  "manageCategoryPopup": {
    "title": "Étape 1/2",
    "buttonNewCategory": "Ajouter une nouvelle catégorie",
    "buttonEditCategory": "Modifier la catégorie",
    "changeButton": "Changer l'icône",
    "nextStep": "Étape suivante",
    "cancelButton": "Annuler",
    "inputs": {
      "categoryPlaceholder": "Entrez le nom de la catégorie",
      "categoryLabel": "Nom de la catégorie",
      "descriptionPlaceholder": "Entrez la description",
      "descriptionLabel": "Description"
    }
  },
  "iconPickerCategoryPopup": {
    "buttons": {
      "backButton": "Retour",
      "choseIconButton": "Choisir une icône pour la catégorie"
    },
    "categories": {
      "performance": "Performance",
      "communication": "Communication",
      "teamCulture": "Culture d'équipe",
      "learning": "Apprentissage"
    }
  },
  "translationOverviewCategory": {
    "title": "Étape 2/2",
    "description": "Vérifier la traduction dans d'autres langues",
    "subtitle": "Nous utilisons la traduction par IA, donc le résultat peut contenir des erreurs",
    "buttons": {
      "backButton": "Retour",
      "buttonNewCategory": "Ajouter une catégorie",
      "buttonEditCategory": "Modifier la catégorie"
    },
    "categoryNameText": "Nom de la catégorie",
    "descriptionText": "Description"
  },
  "changeQuestionPopup": {
    "title": "Modifier la question",
    "buttons": {
      "cancelButton": "Annuler",
      "changeButton": "Modifier la question"
    },
    "inputs": {
      "labelCategory": "Catégorie",
      "placeholderCategory": "Sélectionnez une catégorie",
      "labelQuestion": "Question",
      "placeholderQuestion": "Sélectionnez une question"
    },
    "questionHistory": {
      "lastAskedHint": "Dernière question {{date}}",
      "empty": "(Vide)"
    },
    "errors": {
      "updateFailed": "Échec de la mise à jour de la question planifiée. Veuillez réessayer."
    }
  },
  "blocksSidebar": {
    "placeholder": "Rechercher des blocs",
    "filters": {
      "all": "Tous",
      "text": "Texte",
      "numbers": "Nombres",
      "graphs": "Graphiques"
    }
  },
  "dashboardSidebar": {
    "role": "Rôle",
    "profileSettings": "Paramètres du profil",
    "signOut": "Se déconnecter",
    "powered": "Propulsé par"
  },
  "changeIndicator": {
    "noChange": "Aucun changement"
  },
  "categoryDistributionCard": {
    "questionsCount_one": "{{count}} question",
    "questionsCount_other": "{{count}} questions"
  },
  "gaugeChart": {
    "enpsScore": "Score eNPS"
  },
  "pieChartSimple": {
    "previously": "{{companyScore}} % auparavant",
    "companyBaseline": "Référence de l’entreprise :"
  },
  "tagList": {
    "noTags": "Aucune étiquette"
  },
  "surveyCard": {
    "dropdown": {
      "edit": "Modifier",
      "delete": "Supprimer"
    },
    "useTemplate": "Utiliser le modèle",
    "preview": "Aperçu"
  },
  "translationOverviewQuestion": {
    "questionNameText": "Nom de la question"
  },
  "calendar": {
    "cancel": "Annuler",
    "apply": "Appliquer"
  },
  "categoryPopup": {
    "translationEditItem": {
      "title": "Modifier la traduction",
      "cancel": "Annuler",
      "save": "Enregistrer les modifications"
    }
  },
  "shareReportPopup": {
    "title": "Partager le rapport",
    "accessReport": "Accès au rapport",
    "anyoneWithLink": "Toute personne ayant le lien",
    "copyLink": "Copier le lien"
  },
  "surveyBuilderPopup": {
    "surveyInfoPopup": {
      "title": "Modifier la traduction",
      "tags": "Étiquettes",
      "cancel": "Annuler",
      "save": "Enregistrer les modifications"
    },
    "surveyPublishPopup": {
      "title": "Publier une enquête",
      "surveyTitle": "Titre de l'enquête",
      "surveyDescription": "Description de l'enquête",
      "tags": "Étiquettes",
      "audienceSize": "Taille de l'audience",
      "startDate": "Date de début",
      "distributionMethods": "Méthodes de distribution",
      "cancel": "Annuler",
      "save": "Enregistrer les modifications"
    },
    "surveyQuestionPopup": {
      "title": "Modifier la traduction",
      "options": "Options",
      "cancel": "Annuler",
      "save": "Enregistrer les modifications"
    }
  },
  "userManagementRow": {
    "seeDetails": "Voir les détails",
    "leaderTag": "Leader",
    "roleChangeNotAllowed": "Seuls les administrateurs peuvent modifier les rôles des utilisateurs."
  },
  "errorScreen": {
    "notFound": {
      "title": "Page introuvable",
      "description": "Il semble que cette page ait ete deplacee ou n'existe plus. Reprenons le bon chemin : allez a la Vue d'ensemble ou revenez a la page precedente.",
      "secondaryCta": "Revenir a la page precedente",
      "primaryCta": "Aller a la Vue d'ensemble"
    },
    "generic": {
      "title": "Une erreur inattendue s'est produite",
      "description": "Nous travaillons deja a tout retablir. Reessayez ou revenez en arriere pour continuer la ou tout fonctionne correctement.",
      "secondaryCta": "Reessayer",
      "primaryCta": "Retour"
    }
  },
  "deliveryPausedBanner": {
    "title": "L'envoi des questions est en pause",
    "description": {
      "manual": "L'envoi de vos questions est actuellement en attente. Contactez le support pour plus d'informations.",
      "subscription_canceled": "Votre abonnement a été annulé et l'envoi des questions a été arrêté. Contactez le support pour le réactiver.",
      "subscription_past_due": "Nous n'avons pas pu traiter votre paiement. L'envoi des questions est en attente jusqu'à la mise à jour du paiement.",
      "subscription_unpaid": "Votre paiement est en retard et l'envoi des questions a été suspendu. Contactez le support pour résoudre ce problème.",
      "subscription_paused": "Votre abonnement est en pause et l'envoi des questions est en attente. Contactez le support pour le reprendre."
    },
    "contactSupport": "Contacter le support"
  },
  "globalBanner": {
    "dismissFailed": "Impossible d'enregistrer votre choix. Veuillez réessayer."
  },
  "setupIncompleteBanner": {
    "title": "Terminez la configuration pour commencer à recevoir des retours",
    "description": "Configurez votre organisation pour commencer à recueillir les avis de votre équipe. Cela prend moins de 15 minutes.",
    "completeSetupMessage": "Terminer la configuration"
  }
}
